var map = {
	"./1000.png": "5efe",
	"./12000.png": "ce43",
	"./3000.png": "7c44",
	"./8000.png": "880c",
	"./buttonImmediately.png": "a8170",
	"./candies-banner.png": "0cbc",
	"./candies.png": "cded",
	"./draw.png": "efcf",
	"./first-crown.png": "b87d",
	"./max-dialog.png": "8f0d",
	"./max-exchange.png": "e7e3",
	"./min-button.png": "7367",
	"./min-candies.png": "abbf",
	"./min-dialog.png": "2cd6c",
	"./mincan-exchange.png": "65ee",
	"./rules.png": "17ec",
	"./second-crown.png": "e8134",
	"./star-star.png": "3e30",
	"./third-crown.png": "956e",
	"./win-list.png": "6368",
	"./winners-fisrt.png": "8f3c",
	"./winners.png": "7aa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49c4";